import React, { useState } from 'react'
import './Navigation.css'
import { Link } from 'react-scroll';

const Navigation = () => {
    const [secondText, setsecondText] = useState(false)
    const [firstText, setfirstText] = useState(true)
    const [dropDownHandle, setdropDownHandle] = useState(false)


    const handleMouseEnter = () => {
        setsecondText(true)
        setfirstText(false)
    }

    const handleMouseLeave = () => {
        setsecondText(false)
        setfirstText(true)
    }
    const handleDropDown = () => {
        setdropDownHandle(!dropDownHandle)
    }


    return (





        <div className='box'>
            <nav>
                <div className='firstBox'>
                    <div className='firstTextBox'>
                        {firstText && <h3 className={` ${firstText ? 'slide-up' : 'slide-down'}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>SIMPLICITY</h3>}
                        {secondText && <h3 className={` ${secondText ? 'slide-up-grand' : ''}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>SPACE</h3>}
                    </div>
                </div>
                <div className='secondBox'>

                    <li className='top'>Home</li>
                    <li className='top'>
                        <Link to="About" smooth={true} duration={1000}>About</Link>
                    </li>
                    <li className='top'>
                        <Link to="Blogs" smooth={true} duration={1000}>Blogs</Link>
                    </li>
                    <li className='top'>
                        <Link to="Contact" smooth={true} duration={1500}>Contact</Link>
                    </li>

                </div>
                <div className='dropdown'>
                    <svg onClick={handleDropDown} xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-menu-2" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#B26C2E" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <line x1="4" y1="6" x2="20" y2="6" />
                        <line x1="4" y1="12" x2="20" y2="12" />
                        <line x1="4" y1="18" x2="20" y2="18" />
                    </svg>

                </div>
            </nav>
            <div className='link'>
                {dropDownHandle && <div className='dropdownBox'>
                    <li className='top'>Home</li>
                    <li className='top'>
                        <Link to="About" smooth={true} duration={1000}>About</Link>
                    </li>
                    <li className='top'>
                        <Link to="Blogs" smooth={true} duration={1000}>Blogs</Link>
                    </li>
                    <li className='top'>
                        <Link to="Contact" smooth={true} duration={1500}>Contact</Link>
                    </li>

                </div>}
            </div></div>



    )
}

export default Navigation

